export default function timeout(ms: number) {
  return new Promise<void>(resolve => (ms > 0 ? setTimeout(resolve, ms) : resolve()));
}
